import { Routes, RouterModule } from '@angular/router';
import { LocalizationComponent } from './localization.component';
import { NgModule } from '@angular/core';
import { LocalizationSettingsComponent } from './localization-settings/localization-settings.component';
import { UnSavedChangesRouteGuard } from 'src/app/shared/routeguards/unsavedChangesRouteGuard';

const routes: Routes = [
    { path: '', component: LocalizationComponent},
    { path: 'grid', component: LocalizationComponent},
    { path: 'edit', component: LocalizationSettingsComponent, canDeactivate: [UnSavedChangesRouteGuard]}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LocalizationRoutingModule {}
